import React, { Component } from 'react'
import FarmList from '../components/FarmList'
import Map from '../components/Map'
import MapFilter from '../components/MapFilter'
import apiRoot from '../common/util/api_root'
import queryString from 'query-string'
import { withStyles } from 'material-ui/styles'

const styles = () => ({
  paper: {
    width: '100vw',
    height: '100vh',
  },
  mapContainer: {
    width: '100%',
    height: '91vh',
    '-ms-display': 'flex',
    display: 'flex',
    flexDirection: 'row',
  },
  filter: {
    fontFamily: 'Proxima Nova, sans-serif',
    '-ms-display': 'flex',
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '70rem',
  },
  mapCanvasContainer: {
    '-ms-flex': 4,
    flex: 4,
    height: '100%',
  },
  mapCanvas: {
    width: '100%',
    height: '100%',
    minWidth: '10rem',
  },
  farmList: {
    display: 'none',
  },
  farmIcon: {
    height: '1rem',
    width: '1rem',
  },
  '@media (min-width: 840px)': {
    farmList: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      height: '100%',
      width: '100%',
      minWidth: '20rem',
    },
  },
})

function getDistanceBetween(lat1, lon1, lat2, lon2) {
  const p = 0.017453292519943295 // Math.PI / 180
  const c = Math.cos
  const a = 0.5 - c((lat2 - lat1) * p) / 2 +
    c(lat1 * p) * c(lat2 * p) *
    (1 - c((lon2 - lon1) * p)) / 2
  return 12742 * Math.asin(Math.sqrt(a)) // 2 * R; R = 6371 km
}

const withinRange = (farm, center, distance) =>
  center.lat === null ||
    center.lng === null
    ? true
    : getDistanceBetween(center.lat, center.lng, farm.Lat, farm.Lng) < distance

const commoditiesRequest = new Request(`${apiRoot}/commodities`)
const distributorsRequest = new Request(`${apiRoot}/distributors`)

class InteractiveMap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      commodities: [],
      distributors: [],
      filterComms: [],
      filterDists: [],
    }
  }

  componentWillMount() {
    fetch(commoditiesRequest)
      .then(response =>
        response.json()
      ).then(commodities =>
        this.setState(prevState =>
          ({
            commodities,
          })
        )
      )

    fetch(distributorsRequest)
      .then(response =>
        response.json()
      ).then(distributors =>
        this.setState(prevState =>
          ({
            distributors,
          })
        )
      )
  }

  updateFilterComms = (comms) =>
    this.setState(prevState =>
      ({ filterComms: comms, }))

  updateFilterDists = (dists) =>
    this.setState(prevState =>
      ({ filterDists: dists, }))

  changeActiveWindow = (markerId) => {
    markerId === this.props.getActiveInfoWindowId
      ? this.props.updateActiveInfoWindowId(null)
      : this.props.updateActiveInfoWindowId(markerId)
  }

  filterWithinRange = (farm) =>
    this.props.mapCenter === null ||
      this.props.distance === null ||
      withinRange(farm, this.props.mapCenter, this.props.distance)

  filterWithinFilteredComms = (farm) => {
    if(this.state.filterComms.length === 0) return true

    const comms = farm.Commodities.map(c => c.CommID)
    return this.state.filterComms
      .every(fc => comms.includes(fc))
  }

  filterWithinFilteredDists = (farm) => {
    if(this.state.filterDists.length === 0) return true

    const dists = farm.Distributors.map(d => d.DistID)
    return this.state.filterDists
      .some(fd => dists.includes(fd))
  }

  render() {
    const {
      distance,
      classes,
      className,
      getActiveInfoWindowId,
      getFarmInfo,
      mapCenter,
      history,
      selectedFarm,
      updateUrlParams,
      zip,
    } = this.props

    const filteredFarms = this.props.farms
      .filter(this.filterWithinRange)
      .filter(this.filterWithinFilteredComms)
      .filter(this.filterWithinFilteredDists)

    return (
      <div className='App'>
        <div className={classes.filterContainer}>
          <MapFilter
            commodities={this.state.commodities}
            distance={distance}
            distributors={this.state.distributors}
            farms={filteredFarms}
            filterClass={classes.filter}
            filterComms={this.state.filterComms}
            filterDists={this.state.filterDists}
            history={history}
            mapCenter={mapCenter}
            updateFilterComms={this.updateFilterComms}
            updateFilterDists={this.updateFilterDists}
            updateUrlParams={updateUrlParams}
            zip={zip}
          />
        </div>
        <div className={classes.mapContainer}>
          <FarmList
            changeActiveWindow={this.changeActiveWindow}
            className={classes.farmList}
            farms={filteredFarms}
            getFarmInfo={getFarmInfo}
          />
          <Map
            activeWindow={getActiveInfoWindowId}
            changeActiveWindow={this.changeActiveWindow}
            containerElement={<div className={classes.mapCanvasContainer} />}
            distance={distance}
            filteredFarms={filteredFarms}
            getFarmInfo={getFarmInfo}
            history={history}
            mapCenter={mapCenter}
            mapElement={<div className={classes.mapCanvas} />}
            selectedFarm={selectedFarm}
            updateUrlParams={updateUrlParams}
            zip={zip}
          />
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(InteractiveMap)



// WEBPACK FOOTER //
// ./src/views/InteractiveMap.js